module.exports = __webpack_public_path__ + "img/header-bg-mobile.a2176c7f.png";